// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"cda5e3f79aa44ec4","5285":"979368007a21437e"}[chunkId] + ".css";
};